import { type FC } from "react";

import { TooltipController } from "../../overlays/components/OverlayControllers.js";
import { type ICustomColDef } from "../DataTable.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import type { ProfileDerivedVariant } from "@/graphql.ts";
import { traverseAndCollect } from "@/ui-modules/core/grid/column-props-factory.ts";

const VariantProfileCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const customColDef: ICustomColDef = props.colDef;

  // this cell covers three knows cases:
  // "profile": ref genome is in props.data.refGenome, for Variant and VCF Variant tables
  // "refVariant.profile": ref genome is in props.data.refVariant.refGenome, for Mutation tables
  // "variant.profile": ref gnome is in props.data.variant.refGenome, for Protein Mutations & Gene Mutations

  const profiles: ProfileDerivedVariant[] = traverseAndCollect(props.data, customColDef.groupField);
  return (
    <TableCell>
      <div className="variant-profile-wrapper">
        {profiles?.map((profile: ProfileDerivedVariant, index: number) => {
          // the list of mutant genomes (ordered by profile order) is accessible from the search attributes of the column definition
          const genomeName: string = customColDef.searchAttributes.values.find(
            (option) => Number(option.key) == profile.genomeId,
          )?.label;
          // const genomeName: string = profile.genomeName; TODO would be safer to embed the genomeName in ProfileDerivedVariantData
          const profileChar = profile.symbol;
          const tooltip = `${props.data && genomeName ? genomeName : ""}: ${
            profileChar === "0" ? "absent" : profileChar === "-" ? "not applicable" : "present"
          }`;
          return (
            <TooltipController content={tooltip} key={`variant-profile-tooltip-${props.data.id}-${index}`}>
              {(tooltipTriggerProps) => (
                <div
                  className={`profile-char${profileChar}`}
                  key={`variant-profile-${props.data.id}-${index}`}
                  {...tooltipTriggerProps}
                />
              )}
            </TooltipController>
          );
        })}
      </div>
    </TableCell>
  );
};

export default VariantProfileCell;
